import { Button, Card, Col, Form, Input, InputNumber, Modal, Popconfirm, Row, Select, Space, Switch, Table } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import system from "../../../config/systematic";
import objectHandle from '../../../utils/baseLib/objectHandle';
import { SocketContext } from '../../../App';
import CreateRequireMent from './CreateRequireMent';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import arrayHandle from "../../../utils/baseLib/arrayHandle";

const { TextArea } = Input;

export default function MenuWarehouseEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const [updateForm] = Form.useForm(); //updateForm 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**显示主配料表的title */
    const [showTitle, setShowTitle] = useState<any>(false);

    /**智库需求详细数据 */
    const [rows, setRows] = useState<any>([]);

    /**单位数据 */
    const [productUnitData, setProductUnitData] = useState<any>();

    /**菜品智库出品部门数据 */
    const [menuWarehouseDepartmentData, setMenuWarehouseDeparymentData] = useState<any>();

    /**菜品智库大分类数据 */
    const [menuWarehouseCategoryData, setMenuWarehouseCategoryData] = useState<any>();

    /**菜品智库小分类数据 */
    const [menuWarehouseTypeData, setMenuWarehouseTypeData] = useState<any>();

    /**烹调方法数据 */
    const [cookMethodData, setCookMethodData] = useState<any>();

    /**地区数据 */
    const [areaData, setAreaData] = useState<any>();

    /**记录选择前的菜品智库大分类 */
    const [defaultCategoryId, setDefaultCategoryId] = useState<any>();

    /**小分类的状态 */
    const [disable, setDisable] = useState<any>(true);

    /**创作年份的文本框状态 */
    const [createdDisable, setCreatedDisable] = useState<any>(true);

    /**用餐性质数据 */
    const [sceneData, setSceneData] = useState<any>();
    const [initialScenesId, setInitialScenesId] = useState<any>([]);

    /**搜索后的菜品智库数据（判断版本使用） */
    const [menuWarehouseData, setMenuWarehouseData] = useState<any>([]);

    /**基础的菜品智库数据（判断版本使用） */
    const [baseMenuWarehouseData, setBaseMenuWarehouseData] = useState<any>([]);

    /**查找后的菜品智库数据（复制需求使用） */
    const [menuWarehouseSearchData, setMenuWarehouseSearchData] = useState<any>([]);

    /**被复制需求的数据（复制需求使用） */
    const [copyTargetData, setCopyTargetData] = useState<any>();

    const [createRequireMentData, setCreateRequireMentData] = useState<any>();
    const [createRequireMentModal, setCreateRequireMentModal] = useState<any>(false);

    const [updateRequireMentVisible, setUpdateRequireMentVisible] = useState<any>(false);
    const [updateRequireMentData, setUpdateRequireMentData] = useState<any>();
    const [currentCategoryData, setCurrentCategoryData] = useState<any>();

    /**需求内容数据 */
    const [expandTypeData, setExpandTypeData] = useState<any>();

    /**生成card的数据 */
    const [cardData, setCardData] = useState<any>([]);
    const [state, setState] = useState<any>(false);

    /** 后端数据Service */
    let wmService = system.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;
    const notificationApi = useNotificationInstance();

    /**数据 */
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;

            // form.setFieldsValue({ branchStoreId: localStorage.getItem("currentBranchStoreId") });
            form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });

            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {

                    if (res.data.superiorMenuWarehouse) {
                        let newDatas: Array<any> = [];
                        newDatas.push({
                            value: res.data.superiorMenuWarehouse.id,
                            label: res.data.superiorMenuWarehouse.foodName,
                            version: res.data.superiorMenuWarehouse.version,
                        })
                        setMenuWarehouseData(newDatas);
                        setBaseMenuWarehouseData(newDatas);
                    }

                    form.setFieldsValue({ baseVersion: res.data.version });
                    form.setFieldsValue({ baseSuperiorMenuWarehouseId: res.data.superiorMenuWarehouseId });

                    const menuWarehouseId = res.data.id;
                    const menuWarehouseTypeId = res.data.menuWarehouseTypeId;

                    if (res.data.created >= 1) {
                        setCreatedDisable(false);
                        form.setFieldsValue({ areaId: res.data.area.id });
                    }
                    else {
                        setCreatedDisable(true);
                    }

                    fetchApi.GET(wmService, {
                        apiId: "expandDetail",
                        apiExtend: 'showRequireMent',
                        apiData: {
                            menuWarehouseId
                        }
                    }).then(async res => {
                        if (res.success) {
                            await splitData(res.data, setRows);
                        }
                    });

                    fetchApi.GET(wmService, {
                        apiId: 'menuWarehouseType',
                        apiVariable: menuWarehouseTypeId
                    }).then(res => {
                        if (res.success) {
                            //console.log(res.data);
                            form.setFieldsValue({ menuWarehouseCategoryId: res.data.menuWarehouseCategoryId });
                            //form.setFieldsValue({ menuWarehouseTypeId: res.data.id });
                        }
                    })

                    const scenesId = res.data.scenesId;

                    let sceneRows;
                    if (objectHandle.isEmpty(scenesId) === false) {
                        sceneRows = scenesId.split('@');
                    }
                    setInitialScenesId(sceneRows);
                    form.setFieldsValue({
                        scenesId: sceneRows
                    })
                }
            })
        }

        const fetchData = async () => {

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseDepartment",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseDeparymentData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseCategory",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseCategoryData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseType",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseTypeData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: "cookMethod",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setCookMethodData(res.data);
                }
            });

            if (data.type !== 'NEW') {
                setDisable(false);
                // setBrandIdDisable(true);
            }

            fetchApi.GET(wmService, {
                apiId: "productUnit",
                apiExtend: 'showList'
            }).then(res => {
                setProductUnitData(res.data);
            });

            fetchApi.GET(wmService, {
                apiId: "area",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAreaData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: 'scene',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setSceneData(res.data);
                }
            });

            // fetchApi.GET(wmService, {
            //     apiId: "brand",
            //     apiExtend: 'showList'
            // }).then(res => {
            //     if (res.success) {
            //         setBrandData(res.data);
            //     }
            // })

            // fetchApi.GET(wmService, {
            //     apiId: "menuWarehouse",
            //     apiExtend: 'getBrandId'
            // }).then(res => {
            //     if (res.success) {
            //         console.log(res.data);

            //         if (res.data.key !== 'manager') {
            //             setBrandIdDisable(true);
            //             form.setFieldsValue({ brandId: res.data.brand.id });
            //         }
            //     }
            // });
        }
        fetchData()
    }, [])

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const created = (e: any) => {
        if (form.getFieldValue('created') >= 1) {
            setCreatedDisable(false);
        }
        else {
            setCreatedDisable(true);
        }
    }

    const getDefaultCategoryToTypeData = (e: any) => {
        fetchApi.GET(wmService, {
            apiId: "menuWarehouseCategory",
            apiExtend: 'getTypeList',
            apiVariable: form.getFieldValue('menuWarehouseCategoryId'),
        }).then(res => {
            if (res.success) {
                setMenuWarehouseTypeData(res.data);
            }
        });
    }

    const getDefaultCategoryData = (e: any) => {
        setDefaultCategoryId(form.getFieldValue('menuWarehouseCategoryId'));
    }

    const getCategoryToTypeData = (menuWarehouseCategoryId: string) => {
        setDisable(false);

        if (menuWarehouseCategoryId !== defaultCategoryId) {
            form.setFieldsValue({ menuWarehouseTypeId: "" });
        }

        fetchApi.GET(wmService, {
            apiId: "menuWarehouseCategory",
            apiExtend: 'getTypeList',
            apiVariable: menuWarehouseCategoryId,
        }).then(res => {
            if (res.success) {
                setMenuWarehouseTypeData(res.data);
            }
        });
    }

    //选择关联菜式后更新版本号
    const selectData = async (e: any, option: any) => {

        // if (Number(option.version) + 1 > form.getFieldValue('baseVersion')) {
        //     fetchApi.GET(wmService, {
        //         apiId: "menuWarehouse",
        //         apiExtend: 'checkSubsidiary',
        //         apiData: {
        //             id: form.getFieldValue('id'),
        //             subsidiary: e
        //         }
        //     }).then(res => {
        //         if (res.data) {
        //             antMessage('error', '警告警告', "选择的菜式是当前菜式的下级,不允许此操作。");
        //             form.setFieldsValue({ superiorMenuWarehouseId: form.getFieldValue('baseSuperiorMenuWarehouseId') });
        //             form.setFieldsValue({ version: form.getFieldValue('baseVersion') });
        //             setMenuWarehouseData(baseMenuWarehouseData);
        //         }
        //         else {
        //             form.setFieldsValue({ version: Number(option.version) + 1 });
        //         }
        //     });
        // }
        // else {
        form.setFieldsValue({ version: Number(option.version) + 1 });
        // }
    }

    //查找数据
    const searchData = async (queryString: any) => {
        if (objectHandle.isEmpty(queryString) === true) {
            console.log('查询不能为空');
            return undefined;
        }

        const res = await fetchApi.GET(wmService, {
            apiId: 'menuWarehouse',
            apiExtend: 'showList',
            apiData: {
                queryString
            }
        })
        newData(res.data, setMenuWarehouseData);
    }

    const newData = async (rows: any, setData: any) => {
        let newData: Array<any> = [];
        for (var j = 0; j < rows.length; j++) {
            newData.push({
                value: rows[j].id,
                label: rows[j].foodName,
                version: rows[j].version,
                disabled: rows[j].id === form.getFieldValue('id') ? true : false
            })
        }
        setData(newData);
    }

    const setVersonOne = async () => {
        form.setFieldsValue({ version: 1 });
        form.setFieldsValue({ superiorMenuWarehouseId: null });
        setMenuWarehouseData([]);
    }

    const resetVerson = async () => {
        form.setFieldsValue({ superiorMenuWarehouseId: form.getFieldValue('baseSuperiorMenuWarehouseId') });
        form.setFieldsValue({ version: form.getFieldValue('baseVersion') });
        setMenuWarehouseData(baseMenuWarehouseData);
    }

    const removeRequireMent = async (menuWarehouseId: any) => {
        fetchApi.GET(wmService, {
            apiId: "expandDetail",
            apiExtend: 'removeRequireMent',
            apiData: {
                menuWarehouseId
            }
        }).then(async res => {
            if (res.success) {
                await refeshRequireMent(menuWarehouseId);
            }
        });
    }

    const copyRequireMent = async (menuWarehouseId: any) => {
        if (copyTargetData) {
            fetchApi.GET(wmService, {
                apiId: "expandDetail",
                apiExtend: 'copyRequireMent',
                apiData: {
                    menuWarehouseId,
                    targetId: copyTargetData
                }
            }).then(async res => {
                if (res.success) {
                    await refeshRequireMent(menuWarehouseId);
                }
            });
        }
    }

    const createRequireMent = async (menuWarehouseId: any) => {
        sendData.menuWarehouseId = menuWarehouseId;
        setCreateRequireMentData(sendData);
        setCreateRequireMentModal(true);
    }

    //关闭新建需求窗口
    const onCloseCreateRequireMent = async (state: boolean) => {
        setCreateRequireMentModal(false);
        if (state) {
            await refeshRequireMent(data.id);
        }
    }

    const openUpdateRequireMent = async (parameterData: any) => {
        const {
            menuWarehouseId,
            expandCategoryId,
            expandCategoryName,
            rulesType
        } = parameterData;

        await fetchApi.GET(wmService, {
            apiId: 'expandType',
            apiExtend: 'showDataToUpdate',
            apiData: {
                menuWarehouseId,
                expandCategoryId,
                rulesType
            }
        }).then(async res => {
            if (res.success) {
                setUpdateRequireMentData({
                    menuWarehouseId,
                    expandCategoryId,
                    expandCategoryName,
                    rulesType,
                    data: res.data
                });

                updateForm.setFieldValue('menuWarehouseId', menuWarehouseId);
                updateForm.setFieldValue('expandCategoryId', expandCategoryId);
                updateForm.setFieldValue('expandCategoryName', expandCategoryName);

                if (rulesType === 'text') {
                    updateForm.setFieldValue('expandTypeName', res.data[0]?.expandTypeName);
                }

                if (rulesType === 'select') {
                    let changeData = await setBaseData(res.data, expandCategoryId);
                    setCurrentCategoryData({
                        expandCategoryId,
                        expandCategoryName,
                        changeData
                    })
                }
            }
        });

        setUpdateRequireMentVisible(true);
    };

    const setBaseData = async (data: any, expandCategoryId: any) => {
        let expandTypes: Array<any> = [];
        let showData: Array<any> = [];
        let expandTypeObj: any = [];

        for (var i = 0; i < data.length; i++) {
            let details = data[i].expandDetails[0];
            expandTypes.push({
                id: details.id,
                expandTypeName: data[i].expandTypeName,
                expandTypeId: details.expandTypeId,
                amount: details.amount,
                productUnitId: details.productUnitId,
                memo: details.memo,
            });

            showData.push(data[i].id);
            expandTypeObj.push(data[i]);
        }

        updateForm.setFieldsValue({ [expandCategoryId]: showData })
        setExpandTypeData(expandTypeObj);
        setCardData(expandTypes);
        await setFormData(expandTypes);

        return expandTypes;
    };


    const setFormData = (expandTypes: any) => {
        for (var j = 0; j < expandTypes.length; j++) {
            updateForm.setFieldsValue({ [expandTypes[j].expandTypeId + "_id"]: expandTypes[j].id });
            updateForm.setFieldsValue({ [expandTypes[j].expandTypeId + "_amount"]: expandTypes[j].amount });
            updateForm.setFieldsValue({ [expandTypes[j].expandTypeId + "_productUnitId"]: expandTypes[j].productUnitId });
            updateForm.setFieldsValue({ [expandTypes[j].expandTypeId + "_memo"]: expandTypes[j].memo });
        }
    }

    /**修改的内容*/
    const handleChange = async (e: any, expandTypeId: any, key: any) => {
        let value = '';
        switch (key) {
            case 'memo':
                value = e.target.value;
                break
            default:
                value = e;
                break
        }

        let findData = await arrayHandle.findValue(cardData, 'expandTypeId', expandTypeId);
        if (findData?.index > -1) {
            cardData[findData?.index][key] = value;
        }
    }

    const updateRequireMent = async () => {
        updateForm.validateFields() //数据校验
            .then(async (values: any) => {
                let changeData = await organizeData(values);
                let nowData = { ...values, changeData };
                const editData = {
                    ...nowData
                }
                fetchApi.POST(wmService, {
                    apiId: "expandDetail",
                    apiExtend: "updateRequireMent",
                    apiData: { ...editData }
                }).then(res => {
                    if (res.success) {
                        antMessage('success', '新建成功', 'success');
                        onCloseUpdateRequireMent(true);
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            })
            .catch((err: any) => {
                console.log(err);
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    }

    //把填写好的数据，先在前端整合再传到后台处理
    const organizeData = (data: any) => {
        let changeData: any = [];
        let expandTypes: any = [];
        let expandCategoryId = data.expandCategoryId;

        switch (updateRequireMentData.rulesType) {
            case 'text':
                changeData.push({
                    expandCategoryId,
                    rulesType: updateRequireMentData.rulesType,
                    expandDetail: data.expandTypeName,
                    oldData: updateRequireMentData.data
                })
                break;

            case 'select':
                for (var j = 0; j < data[expandCategoryId].length; j++) {
                    let expandTypeId = data[expandCategoryId][j];

                    expandTypes.push({
                        id: data[expandTypeId + "_id"],
                        expandTypeId: expandTypeId,
                        amount: data[expandTypeId + "_amount"],
                        productUnitId: data[expandTypeId + "_productUnitId"],
                        memo: data[expandTypeId + "_memo"],
                    })
                    if (j === data[expandCategoryId].length - 1) {
                        changeData.push({
                            expandCategoryId,
                            rulesType: updateRequireMentData.rulesType,
                            expandTypes,
                            oldData: currentCategoryData.changeData
                        })
                    }
                }
                break;
        }

        return changeData;
    }

    const onCloseUpdateRequireMent = async (state: boolean) => {
        setUpdateRequireMentVisible(false);
        setCardData([]);
        setState(!state);
        if (state) {
            await refeshRequireMent(data.id);
        }
    };

    const refeshRequireMent = async (menuWarehouseId: string) => {
        await fetchApi.GET(wmService, {
            apiId: "expandDetail",
            apiExtend: 'showRequireMent',
            apiData: {
                menuWarehouseId
            }
        }).then(async res => {
            if (res.success) {
                await splitData(res.data, setRows);
            }
        });
    }

    const splitData = async (rows: any, setData: any) => {
        let finalData: Array<any> = [];
        let finalState = false;
        for (var i = 0, len = rows.length; i < len; i++) {
            let expandCategoryData = rows[i].expandCategorys;
            let currentId;
            for (var j = 0, j_len = expandCategoryData.length; j < j_len; j++) {
                let rules = JSON.parse(expandCategoryData[j].rules);
                let rulesType = rules?.type ? rules?.type : 'text';
                let expandTypeData = expandCategoryData[j].expandTypes;
                let returnData = await concatData(expandTypeData);
                finalData.push({
                    dataNum: currentId !== rows[i].id ? rows[i].dataNum : 0,
                    menuWarehouseRequireMentId: rows[i].id,
                    menuWarehouseRequireMentName: rows[i].name,
                    expandCategoryName: expandCategoryData[j].expandCategoryName,
                    expandTypeNames: returnData.finalData,
                    expandCategoryId: expandCategoryData[j].id,
                    rulesType
                })

                if (!finalState) {
                    finalState = returnData.updateState;
                }
                currentId = rows[i].id;
            }
        }

        setShowTitle(finalState);
        setData(finalData);
    }

    const concatData = async (rows: any) => {
        let finalData: any;
        let updateState = false;
        for (var i = 0, len = rows.length; i < len; i++) {
            let amountStr = '';
            if (rows[i].expandDetails[0]?.amount) {
                amountStr = rows[i].expandDetails[0]?.amount + rows[i].expandDetails[0]?.productUnit.productUnitName + (rows[i].expandDetails[0]?.memo ? " (" + rows[i].expandDetails[0]?.memo + ") " : '');
            }
            finalData = finalData ? (finalData + " , " + rows[i].expandTypeName + " " + amountStr) : (rows[i].expandTypeName + " " + amountStr);
        }

        if (finalData) {
            updateState = true;
        }

        return { finalData, updateState };
    }

    const searchToCopyData = async (queryString: any) => {
        if (objectHandle.isEmpty(queryString) === true) {
            console.log('查询不能为空');
            return undefined;
        }

        await fetchApi.GET(wmService, {
            apiId: 'menuWarehouse',
            apiExtend: 'showList',
            apiData: {
                queryString
            }
        }).then(res => {
            if (res.success) {
                setMenuWarehouseSearchData(res.data);
            }
        });
    }

    const findDiff = async (arr1: any, arr2: any) => {
        const set1 = new Set(arr1);
        const set2 = new Set(arr2);
        const result = [];

        // 找出在 set1 但不在 set2 中的元素
        for (const item of set1) {
            if (!set2.has(item)) result.push(item);
        }
        // 找出在 set2 但不在 set1 中的元素
        for (const item of set2) {
            if (!set1.has(item)) result.push(item);
        }
        return result; // 返回数组，包含所有差异元素
    }

    const dataToCard = async (e: any, option: any) => {
        let finalData = cardData;
        let createdData = [];

        if (finalData.length > 0) {
            let cardExpandTypeIds = finalData.map((item: { expandTypeId: any; }) => item.expandTypeId);
            const diff = await findDiff(e, cardExpandTypeIds);
            let findData = await arrayHandle.findValue(finalData, 'expandTypeId', diff[0]);

            if (findData?.index > -1) {
                // finalData = await arrayHandle.deleteValue(finalData, 'expandTypeId', diff[0]);
                const deletedData = finalData.filter((item: { expandTypeId: string; }) => item.expandTypeId !== diff[0]);
                finalData = deletedData;
            }
            else {
                createdData.push({
                    id: null,
                    expandTypeName: option[option.length - 1].children,
                    expandTypeId: diff[0],
                    amount: null,
                    productUnitId: null,
                    memo: null
                })
            }
        }
        else {
            createdData.push({
                id: null,
                expandTypeName: option[option.length - 1].children,
                expandTypeId: option[option.length - 1].value,
                amount: null,
                productUnitId: null,
                memo: null
            })
        }

        let concatData = finalData.concat(createdData);
        
        setCardData(concatData);
        await setFormData(concatData);
        setState(!state);
    }

    const selectToCopyData = async (e: any) => {
        setCopyTargetData(e);
    }

    const clearToCopyData = () => {
        setCopyTargetData(null);
    }

    //表头
    const columnsHead = [
        {
            title: '需求',
            dataIndex: 'menuWarehouseRequireMentName',
            width: 100,
            onCell: (record: { dataNum: number; }) => ({
                rowSpan: record.dataNum,
            }),
        },
        {
            title: '需求类型',
            dataIndex: 'expandCategoryName',
            width: 180,
            render: (text: any, record: any) => {
                if (sessionStorage.getItem('isAdmin') === 'true' && data.type === 'EDIT' && showTitle) {
                    return (
                        <Space size="small">
                            <Button onClick={() => openUpdateRequireMent({
                                menuWarehouseId: data.id,
                                expandCategoryId: record.expandCategoryId,
                                expandCategoryName: record.expandCategoryName,
                                rulesType: record.rulesType
                            })}>修改</Button>
                            {text}
                        </Space>
                    )
                }
                else {
                    return (
                        <Space size="small">
                            {text}
                        </Space>
                    )
                }
            }
        },
        {
            title: '需求内容',
            dataIndex: 'expandTypeNames',
        },
    ];

    //传关参数
    let sendData = {
        type: 'EDIT',
        menuWarehouseId: '',
    }

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuWarehouse',
        mountDataOptions: {
            userMount: {
                isBranchStore: true
            }
        }
    };

    return (
        <>
            <Modal
                title="修改需求"
                open={updateRequireMentVisible}
                onOk={updateRequireMent}
                onCancel={() => onCloseUpdateRequireMent(false)}
                width={1000}
            >
                <Form
                    form={updateForm}
                    name="Update"
                    onFinish={updateRequireMent}
                >
                    <Row gutter={[16, 8]}>
                        <Col span={24}>
                            <Form.Item
                                label="智库菜品Id"
                                name="menuWarehouseId"
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="需求分类Id"
                                name="expandCategoryId"
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="需求分类"
                                name="expandCategoryName"
                            >
                                <Input style={{ color: 'yellow' }} disabled />
                            </Form.Item>
                        </Col>

                        {
                            updateRequireMentData ?
                                updateRequireMentData.rulesType !== 'text' ?
                                    <Col span={24}>
                                        <Form.Item
                                            label={currentCategoryData.expandCategoryName}
                                            name={currentCategoryData.expandCategoryId}
                                            rules={[{ required: updateRequireMentData.rulesType !== 'text' ? true : false, message: '请选择' + currentCategoryData.expandCategoryName + '!' }]}
                                        >
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                onSearch={(e) => getList.searchEx('expandType', setExpandTypeData, e, expandTypeData, {
                                                    apiExtend: 'showListForRequireMent',
                                                    andWhereObj: {
                                                        expandCategoryId: currentCategoryData.expandCategoryId,
                                                        mountDataOptions: {
                                                            userMount: {
                                                                isDept: true
                                                            }
                                                        },
                                                    }
                                                })}
                                                onChange={(e, option) => dataToCard(e, option)}
                                                placeholder={currentCategoryData.expandCategoryName}
                                                optionFilterProp="children"
                                                filterOption={(input, option: any) => {
                                                    return true
                                                }}>
                                                {getList.generalEx(expandTypeData, {
                                                    itemName: "expandTypeName",
                                                    includeNull: false
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    :
                                    <Col span={24}>
                                        <Form.Item
                                            label="需求内容"
                                            name="expandTypeName"
                                            rules={[{ required: updateRequireMentData.rulesType === 'text' ? true : false, message: '请输入需求内容!' }]}>
                                            <TextArea
                                                maxLength={250}
                                                showCount
                                            />
                                        </Form.Item>
                                    </Col>
                                : null
                        }

                        {
                            cardData.length > 0 ? cardData.map((item: any, index: any) => {
                                return (
                                    <>
                                        <Col span={8}>
                                            <Card
                                                title={item.expandTypeName}
                                            >
                                                <Form.Item
                                                    label="id"
                                                    name={item.expandTypeId + '_id'}
                                                >
                                                    <Input disabled />
                                                </Form.Item>

                                                <Form.Item
                                                    label="定量"
                                                    name={item.expandTypeId + '_amount'}
                                                    rules={[{ required: cardData.length > 0 ? true : false, message: '请填写定量!' }]}
                                                >
                                                    <InputNumber placeholder="定量" min={0.01} step={0.01} onChange={(e) => handleChange(e, item.expandTypeId, 'amount')} />
                                                </Form.Item>

                                                <Form.Item
                                                    label="单位"
                                                    name={item.expandTypeId + '_productUnitId'}
                                                    rules={[{ required: true, message: '请输入单位!' }]}>
                                                    <Select
                                                        showSearch
                                                        placeholder="单位"
                                                        optionFilterProp="children"
                                                        onChange={(e) => handleChange(e, item.expandTypeId, 'productUnitId')}
                                                        filterOption={(input, option: any) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                        {getList.generalEx(productUnitData, {
                                                            itemName: "productUnitName",
                                                            includeNull: false
                                                        })}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    label="备注"
                                                    name={item.expandTypeId + '_memo'}>
                                                    <TextArea
                                                        placeholder="备注"
                                                        onChange={(e) => handleChange(e, item.expandTypeId, 'memo')}
                                                        autoSize={{ minRows: 2, maxRows: 5 }}
                                                        showCount
                                                        maxLength={250}
                                                    />
                                                </Form.Item>
                                            </Card>
                                        </Col>
                                    </>
                                )
                            })
                                : null
                        }
                    </Row>
                </Form>
            </Modal>
            <br /><br />
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '菜品智库'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1400}
            >
                <Form
                    form={form}
                    initialValues={{ "price": 999, "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[16, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="门店Id"
                                name="branchStoreId"
                            >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        {/* <Col span={8}>
                            <Form.Item
                                label="品牌"
                                name="brandId"
                                rules={[{ required: true, message: '请输入品牌!' }]}>
                                <Select
                                    showSearch
                                    disabled={brandIdDisable}
                                    placeholder="品牌"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(brandData, 'brandName')}
                                </Select>
                            </Form.Item>
                        </Col> */}

                        <Col span={6}>
                            <Form.Item
                                label="作品号"
                                name="opusNumber">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="出品部门"
                                name="menuWarehouseDepartmentId">
                                <Select
                                    placeholder="出品部门"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(menuWarehouseDepartmentData, {
                                        itemName: "menuWarehouseDepartmentName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="前一个版本"
                                name="superiorMenuWarehouseId"
                                rules={[{ message: '请选择前一个版本!' }]}>
                                {/* <Select
                                    showSearch
                                    placeholder="选择前一个版本"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(menuWarehouseData, 'foodName')}
                                </Select> */}

                                <Select
                                    onSearch={(e) => searchData(e)}
                                    onSelect={selectData}
                                    showSearch
                                    placeholder="选择前一个版本"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                    // options={getList.generalSelcetOption(menuWarehouseData, "foodName")}
                                    options={menuWarehouseData}
                                >
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="原版本ID"
                                name="baseSuperiorMenuWarehouseId">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="原版本号"
                                name="baseVersion">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="版本号"
                                name="version">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item name="resetVerson">
                                <Space>
                                    <Button type="primary" onClick={setVersonOne}>设为第一版本</Button>
                                    <Button type="primary" onClick={resetVerson}>重置版本</Button>
                                </Space>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="创作年份"
                                name="created">
                                <InputNumber min={1992} max={2992} onChange={created} addonBefore="创于" addonAfter="年" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="创作地"
                                name="areaId"
                                rules={[{ required: createdDisable ? false : true, message: '请选择创作地!' }]}
                            >
                                <Select
                                    disabled={createdDisable}
                                    placeholder="创作地"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(areaData, {
                                        itemName: "areaName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="菜名"
                                name="foodName"
                                rules={[{ required: true, message: '请输入菜名!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="菜式英文名"
                                name="foodNameEn"
                            // rules={[{ required: true, message: '请输入菜式英文名!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="菜品智库大分类"
                                name="menuWarehouseCategoryId"
                                rules={[{ required: true, message: '菜品智库大分类!' }]}>
                                <Select
                                    showSearch
                                    placeholder="菜品智库大分类"
                                    optionFilterProp="children"
                                    onSelect={getCategoryToTypeData}
                                    onFocus={getDefaultCategoryData}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(menuWarehouseCategoryData, {
                                        itemName: "menuWarehouseCategoryName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="菜品智库小分类"
                                name="menuWarehouseTypeId"
                                rules={[{ required: true, message: '菜品智库小分类!' }]}>
                                <Select
                                    disabled={disable}
                                    showSearch
                                    placeholder="菜品智库小分类"
                                    optionFilterProp="children"
                                    onMouseEnter={getDefaultCategoryToTypeData}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(menuWarehouseTypeData, {
                                        itemName: "menuWarehouseTypeName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="曾用菜名"
                                name="usedFoodName">
                                <Input disabled={sessionStorage.getItem('isAdmin') === 'true' ? false : true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="曾用英文菜名"
                                name="usedFoodNameEn">
                                <Input disabled={sessionStorage.getItem('isAdmin') === 'true' ? false : true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="菜式描述"
                                name="description"
                            >
                                <Input placeholder="如：外脆内嫩 鲜甜香滑 / 精酿啤酒、椰子汁、姜汁" />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="用餐性质"
                                name="scenesId"
                                initialValue={initialScenesId} >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    placeholder="选择用餐性质"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(sceneData, 'sceneName', 'id', undefined, false)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                name="menuWarehouseRequireMentTable"
                            >
                                <Table
                                    bordered={true}
                                    showHeader={false}
                                    pagination={false}
                                    rowKey={(record: any) => record.id}
                                    columns={columnsHead}
                                    dataSource={rows}
                                    title={() => sessionStorage.getItem('isAdmin') === 'true' ? data.type === 'EDIT' ?
                                        showTitle ?
                                            <Popconfirm title="确定清空需求吗？" onConfirm={() => removeRequireMent(data.id)}>
                                                <Button danger>清空需求</Button>
                                            </Popconfirm>
                                            : <Space>
                                                <Button type="primary" onClick={() => createRequireMent(data.id)}>新建需求</Button>
                                                <Button type="primary" onClick={() => copyRequireMent(data.id)}>复制其他菜的需求</Button>
                                                <Select
                                                    style={{ width: 250 }}
                                                    onSearch={(e) => searchToCopyData(e)}
                                                    onSelect={selectToCopyData}
                                                    onClear={clearToCopyData}
                                                    allowClear
                                                    showSearch
                                                    placeholder="输入菜式名称,选择想复制的菜式"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option: any) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                    {getList.generalEx(menuWarehouseSearchData, {
                                                        itemName: "foodName",
                                                        includeNull: false
                                                    })}
                                                </Select>
                                            </Space>
                                        : null : null}
                                >
                                </Table>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="烹调方法"
                                name="cookMethodId"
                                rules={[{ required: true, message: '烹调方法!' }]}>
                                <Select
                                    showSearch
                                    placeholder="烹调方法"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(cookMethodData, {
                                        itemName: "cookMethodName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="单位"
                                name="productUnitId"
                                rules={[{ required: true, message: '请输入单位!' }]}>
                                <Select
                                    showSearch
                                    placeholder="单位"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(productUnitData, {
                                        itemName: "productUnitName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="价格"
                                name="price">
                                <InputNumber min={0} addonBefore="¥" addonAfter="元" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="备注"
                                name="memo"
                            >
                                <TextArea
                                    placeholder="备注"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="介绍"
                                name="introduction"
                            >
                                <TextArea
                                    placeholder="介绍"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="创作理念"
                                name="creativeConcept"
                            >
                                <TextArea
                                    placeholder="创作理念"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>

            {createRequireMentModal
                ? (<CreateRequireMent
                    closeModal={onCloseCreateRequireMent} data={createRequireMentData} />)
                : null}
        </>
    )
}